package com.bikompanion.domain.usecase

import dev.zacsweers.metro.Inject
import com.bikompanion.domain.BikeStation

/**
 * Which of a network's stations actually moved between two loads.
 *
 * A station is only compared against itself: one that appears for the first time has nothing to
 * have moved from, and flagging every station of a first load would say nothing anyway.
 */
@Inject
class FindChangedStationsUseCase {
    operator fun invoke(
        previous: List<BikeStation>,
        fresh: List<BikeStation>,
    ): List<String> {
        val before = previous.associateBy { it.id }
        return fresh.mapNotNull { station ->
            val old = before[station.id] ?: return@mapNotNull null
            val moved = old.freeBikes != station.freeBikes ||
                old.electricBikes != station.electricBikes ||
                old.emptySlots != station.emptySlots
            if (moved) station.id else null
        }
    }
}
